import { ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-outstanding-report',
  templateUrl: './outstanding-report.component.html',
  styleUrl: './outstanding-report.component.scss'
})
export class OutstandingReportComponent {
  @ViewChild('printSection') printSection!: ElementRef;
  contractDetailsForm: any;
  bookSellerName: any;
  startDate:any = '';
  endDate:any = '';
  repName = '';
  offRepName = '';
  booksellerName = '';
  reportType = '';
  currentDate= new Date();
  OutstandingInDetailFormBeans: any = []
  UnpaidOutstandingInDetailFormBeans: any = []
  OutstandingB: any = []
  UnpaidOutstandingB: any =[]

  OutStandingIDTotal: number = 0;
  OutStandingIDNetAmtTotal: number = 0;
  OutStandingIDUnPaidTotal: number = 0;
  OutStandingIDCrdtTotal: number = 0;

  UnpaidOutStandingIDTotal: number = 0;
  UnpaidOutStandingIDNetAmtTotal: number = 0;
  UnpaidOutStandingIDUnPaidTotal: number = 0;
  UnpaidOutStandingIDCrdtTotal: number = 0;



  totalInvAmount: number = 0;
  totalPaidAmount: number = 0;
  totalUnpaidAmount: number = 0;
  totalCrdtAmount: number = 0;


  unpaidtotalInvAmount: number = 0;
  unpaidtotalPaidAmount: number = 0;
  unpaidtotalUnpaidAmount: number = 0;
  unpaidtotalCrdtAmount: number = 0;

   constructor(
      private dialogRef: MatDialogRef<OutstandingReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
    ) {
      this.contractDetailsForm = this.fb.group({
        start: ['', Validators.required],
        end: ['', Validators.required],
        // other form controls
      });
    }

  getReportType(event) {
    // console.log(event.value);
    this.reportType = event.value;
  }
  ngOnInit(): void {
    debugger

    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.reportType = this.data['reportType'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.booksellerName = this.data['booksellerName'];

    this.filters()

  }
  replist:any;
  filters() {
    // let repname:any=this.repName
    // if(repname!=""){
    //   repname=[this.repName]
    // }

      // const req:any = {
        
      //   "start_date":this.startDate,
      //   "end_date":this.endDate,
      //   "rep_name":this.repName,
      //   "office_rep_name":this.offRepName,
      //   "book_seller_name":this.booksellerName
        
      // }
    
      const req: any = {};

if (this.startDate?.toString().trim()) {
  req.start_date = this.startDate;
}

if (this.endDate?.toString().trim()) {
  req.end_date = this.endDate;
}

if (Array.isArray(this.repName) && this.repName.length > 0) {
  req.rep_name = this.repName;
}

if (Array.isArray(this.offRepName) && this.offRepName.length > 0) {
  req.office_rep_name = this.offRepName;
}

if (Array.isArray(this.booksellerName) && this.booksellerName.length > 0) {
  req.book_seller_name = this.booksellerName;
}

console.log(req);
// Send `req` to your API

    this.service.getBookOutstandingInDetail(req).subscribe((data: any) => {
    console.log("outstanding 3", data)
    this.OutstandingInDetailFormBeans = data as any;
      
    this.OutStandingIDTotal = 0;
    this.OutStandingIDNetAmtTotal = 0;
    this.OutStandingIDUnPaidTotal = 0;
    this.OutStandingIDCrdtTotal = 0;




    
    for (let data of this.OutstandingInDetailFormBeans) {


      for (let data1 of data.rep_data) {
        console.log("this.data1",data1);
        this.OutStandingIDTotal += parseInt(data1.inv_amt_total) || 0;
        this.OutStandingIDNetAmtTotal += parseInt(data1.net_amt_total) || 0;
        this.OutStandingIDUnPaidTotal += parseInt(data1.unpaid_amt_total) || 0;
        this.OutStandingIDCrdtTotal += parseInt(data1.crdt_amt_total) || 0;
      }
      
    }

    console.log("this.data",data);
    console.log("this.OutStandingIDTotal", this.OutStandingIDTotal);
    console.log("this.OutStandingIDNetAmtTotal", this.OutStandingIDNetAmtTotal);
    console.log("this.OutStandingIDUnPaidTotal", this.OutStandingIDUnPaidTotal);
    console.log("this.OutStandingIDCrdtTotal", this.OutStandingIDCrdtTotal);
    
    
    });
    

    // this.service.getBookOutstandingBriefly(req).subscribe((data: any) => {
    //   this.OutstandingB = data as any;
    //   // Reset overall totals
    //   this.totalInvAmount = 0;
    //   this.totalPaidAmount = 0;
    //   this.totalUnpaidAmount = 0;

    //   // Calculate totals for each representative
    //   this.OutstandingB.forEach(repData => {
    //     let invTotal = 0;
    //     let paidTotal = 0;
    //     let balTotal = 0;

    //     repData.rep_data.forEach(data1 => {
    //       invTotal += parseFloat(data1.inv_amt_total) || 0;
    //       paidTotal += parseFloat(data1.net_amt_total) || 0;
    //       balTotal += parseFloat(data1.unpaid_amt_total) || 0;
    //     });

    //     // Assign computed totals to each representative
    //     repData.inv_Total = invTotal;
    //     repData.paid_Total = paidTotal;
    //     repData.bal_Total = balTotal;

    //     // Add to overall totals
    //     this.totalInvAmount += invTotal;
    //     this.totalPaidAmount += paidTotal;
    //     this.totalUnpaidAmount += balTotal;
    //   });

    // });

    this.service.getBookOutstandingBriefly(req).subscribe((data: any) => {
      this.OutstandingB = data || [];
    
      this.totalInvAmount = 0;
      this.totalPaidAmount = 0;
      this.totalUnpaidAmount = 0;
    
      this.OutstandingB.forEach(repData => {
        let invTotal = 0;
        let paidTotal = 0;
        let balTotal = 0;
        let crdtTotal = 0;
    
        if (Array.isArray(repData.rep_data)) {
          repData.rep_data.forEach(data1 => {
            const inv = parseFloat(data1.inv_amt_total) || 0;
            const paid = parseFloat(data1.net_amt_total) || 0;
            const bal = parseFloat(data1.unpaid_amt_total) || 0;
            const crdt = parseFloat(data1.crdt_amt_total) || 0;
    
            invTotal += inv;
            paidTotal += paid;
            balTotal += bal;
            crdtTotal += crdt;
          });
        }
    
        repData.inv_Total = invTotal;
        repData.paid_Total = paidTotal;
        repData.bal_Total = balTotal;
        repData.crdt_Total = crdtTotal;

    
        this.totalInvAmount += invTotal;
        this.totalPaidAmount += paidTotal;
        this.totalUnpaidAmount += balTotal;
        this.totalCrdtAmount += crdtTotal;
      });
    
      console.log('Final Totals:', {
        totalInv: this.totalInvAmount,
        totalPaid: this.totalPaidAmount,
        totalUnpaid: this.totalUnpaidAmount,
        totalCrdt: this.totalCrdtAmount,
        OutstandingB: this.OutstandingB
      });
    });
    
 
    

    this.service.getBookUnpaidOutstandingIndetail(req).subscribe((data: any) => {
      console.log("outstanding 3", data)
      this.UnpaidOutstandingInDetailFormBeans = data as any;
        
      this.UnpaidOutStandingIDTotal = 0;
      this.UnpaidOutStandingIDNetAmtTotal = 0;
      this.UnpaidOutStandingIDUnPaidTotal = 0;
      this.UnpaidOutStandingIDCrdtTotal = 0;
      
      for (let data of this.UnpaidOutstandingInDetailFormBeans) {
  
  
        for (let data1 of data.rep_data) {
          console.log("this.data1",data1);
          this.UnpaidOutStandingIDTotal += parseInt(data1.inv_amt_total) || 0;
          this.UnpaidOutStandingIDNetAmtTotal += parseInt(data1.net_amt_total) || 0;
          this.UnpaidOutStandingIDUnPaidTotal += parseInt(data1.unpaid_amt_total) || 0;
          this.UnpaidOutStandingIDCrdtTotal += parseInt(data1.crdt_amt_total) || 0;
        }
        
      }
  
      console.log("this.data",data);
      console.log("this.UnpaidOutStandingIDTotal", this.UnpaidOutStandingIDTotal);
      console.log("this.UnpaidOutStandingIDNetAmtTotal", this.UnpaidOutStandingIDNetAmtTotal);
      console.log("this.UnpaidOutStandingIDUnPaidTotal", this.UnpaidOutStandingIDUnPaidTotal);
      console.log("this.UnpaidOutStandingIDCrdtTotal", this.UnpaidOutStandingIDCrdtTotal);
      
      
      });

      this.service.getBookUnpaidOutstandingBriefly(req).subscribe((data: any) => {
        this.UnpaidOutstandingB = data || [];
      
        this.unpaidtotalInvAmount = 0;
        this.unpaidtotalPaidAmount = 0;
        this.unpaidtotalUnpaidAmount = 0;
      
        this.UnpaidOutstandingB.forEach(repData => {
          let invTotal = 0;
          let paidTotal = 0;
          let balTotal = 0;
          let crdtTotal = 0;
      
          if (Array.isArray(repData.rep_data)) {
            repData.rep_data.forEach(data1 => {
              const inv = parseFloat(data1.inv_amt_total) || 0;
              const paid = parseFloat(data1.net_amt_total) || 0;
              const bal = parseFloat(data1.unpaid_amt_total) || 0;
              const crdt = parseFloat(data1.crdt_amt_total) || 0;
      
              invTotal += inv;
              paidTotal += paid;
              balTotal += bal;
              crdtTotal += crdt;
            });
          }
      
          repData.inv_Total = invTotal;
          repData.paid_Total = paidTotal;
          repData.bal_Total = balTotal;
          repData.crdt_Total = crdtTotal;
  
      
          this.unpaidtotalInvAmount += invTotal;
          this.unpaidtotalPaidAmount += paidTotal;
          this.unpaidtotalUnpaidAmount += balTotal;
          this.unpaidtotalCrdtAmount += crdtTotal;

          console.log(`Subtotals for ${repData.ofc_rep_name}:`, {
            invTotal, paidTotal, balTotal, crdtTotal
          });
        });
      
        console.log('Final Totals:', {
          totalInv: this.unpaidtotalInvAmount,
          totalPaid: this.unpaidtotalPaidAmount,
          totalUnpaid: this.unpaidtotalUnpaidAmount,
          totalCrdt: this.unpaidtotalCrdtAmount,
          UnpaidOutstandingB: this.UnpaidOutstandingB
        });
      });

    
}
// printPageA4() {
//   const printContent = document.getElementById('print-section');
//   const WindowPrt = window.open('', '', 'width=1400,height=900');

//   WindowPrt.document.write(`
//     <html>
//       <head>
//         <title>Book Outstanding Report</title>
//         <style>

//           @page {
//             size: A3 landscape;
//             margin-left: 10mm;
//           }

//           body {
//             font-family: Arial, sans-serif;
//             font-size: 13px;
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//             margin: 0;
//             padding: 0;
//           }

//           table {
//             width: 100%;
//             border-collapse: collapse;
//           }

//           th, td {
//             border: 1px solid black;
//             padding: 6px;
//           }

//           /* Main header wrapper - only on first page */
//           .main-header-wrapper {
//             page-break-inside: avoid;
//             page-break-after: auto;
//           }

//           /* Column header - repeats on every page */
//           .repeat-header {
//             display: table-header-group;
//           }

//           @media print {
//             /* Ensure column headers repeat on every page */
//             .repeat-header {
//               display: table-header-group !important;
//             }

//             /* Main header only on first page */
//             .main-header-wrapper {
//               display: block;
//             }

//             /* Avoid breaking rows in the middle */
//             tr {
//               page-break-inside: avoid !important;
//             }

//             tbody tr {
//               page-break-inside: avoid !important;
//             }

//             /* Allow page breaks between rows */
//             tbody {
//               page-break-inside: auto;
//             }

//             /* Ensure backgrounds print */
//             * {
//               -webkit-print-color-adjust: exact !important;
//               print-color-adjust: exact !important;
//             }
//           }

//         </style>
//       </head>

//       <body>${printContent?.innerHTML}</body>

//     </html>
//   `);

//   WindowPrt.document.close();
//   WindowPrt.focus();

//   setTimeout(() => {
//     WindowPrt.print();
//     WindowPrt.close();
//   }, 600);
// }
  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }


printPage4(): void {
  const printContent = document.getElementById('print-section');
  const WindowPrt = window.open('', '', 'width=1200,height=900');

  WindowPrt.document.write(`
    <html>
      <head>
        <title>.</title>

        <style>

          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          /* ------- PAGE SETUP ------- */
          @page {
            size: A4 portrait;
            margin: 10mm 12mm; /* Balanced left + right */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 10px;
          }

          /* ------- TABLE BASE STYLE ------- */
          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: auto;
          }

          th, td {
            border: 1px solid black !important;
            padding: 6px 8px;
            white-space: nowrap;
            text-align: left;
            vertical-align: middle;
          }

          /* ------- THEAD REPEAT ON EVERY PAGE ------- */
          thead {
            display: table-header-group !important;
          }

          thead th {
            background-color: #e8e8e8 !important;
            text-align: center;
            font-weight: bold;
          }

          /* Remove duplicate right-border */
          th:last-child,
          td:last-child {
            border-right-width: 1px !important;
          }

          tr, td, th {
            page-break-inside: avoid !important;
          }

          /* Disable wrapping if required */
          .no-wrap {
            white-space: nowrap !important;
          }

          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent?.innerHTML}
      </body>

    </html>
  `);

  WindowPrt.document.close();

  WindowPrt.onload = () => {
    WindowPrt.focus();
    setTimeout(() => {
      WindowPrt.print();
      WindowPrt.close();
    }, 400);
  };
}



printPageA(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          /* ===== FORCE COLORS & BORDERS ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 PORTRAIT ===== */
          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm; /* top right bottom left */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 10px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;
          }

          th, td {
            border: 1px solid #000;
            padding: 6px;
            white-space: nowrap;
            vertical-align: middle;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== HIDE NON-PRINT ===== */
          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt.document.close();
  WindowPrt.focus();

  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 500);
}
// printPage42() {
//   const printContents = document.getElementById('print-section')?.innerHTML;
  
//   if (!printContents) {
//     console.error('Print section not found');
//     return;
//   }

//   const printWindow = window.open('', '', 'width=800,height=600');
  
//   if (!printWindow) {
//     console.error('Failed to open print window');
//     return;
//   }

//   printWindow.document.write(`
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <title>Office Rep Unpaid Outstanding Report</title>
//       <style>
//         /* A4 Portrait Page Setup */
//         @page {
//           size: A4 portrait;
//           margin: 15mm 10mm 15mm 10mm;
//         }

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: Arial, sans-serif;
//           font-size: 12px;
//           line-height: 1.4;
//         }

//         .container {
//           width: 100%;
//         }

//         /* Table Styling */
//         table {
//           width: 100%;
//           border-collapse: collapse;
//           page-break-inside: auto;
//         }

//         thead {
//           display: table-header-group;
//         }

//         tbody {
//           display: table-row-group;
//         }

//         tr {
//           page-break-inside: avoid;
//           page-break-after: auto;
//         }

//         th, td {
//           padding: 6px;
//           border: 1px solid black;
//           font-size: 16px;
//         }

//         th {
//           font-weight: bold;
//         }

//         /* Grand Total Row */
//         tr[style*="background-color:#c8753f"] {
//           background-color: #c8753f !important;
//           font-weight: bold;
//           font-size: 16px;
//           color: white;
//         }

//         /* Hide elements with noPrint class */
//         .noPrint {
//           display: none !important;
//         }

//         /* Print-specific adjustments */
//         @media print {
//           body {
//             print-color-adjust: exact;
//             -webkit-print-color-adjust: exact;
//           }

//           thead {
//             display: table-header-group;
//           }

//           tbody tr {
//             page-break-inside: avoid;
//           }

//           /* Ensure grand total background prints */
//           tr[style*="background-color:#c8753f"] {
//             background-color: #c8753f !important;
//             -webkit-print-color-adjust: exact;
//             print-color-adjust: exact;
//           }
//         }

//         /* Text Alignment */
//         td[style*="text-align:right"],
//         th[style*="text-align:right"] {
//           text-align: right;
//         }

//         td[style*="text-align:center"],
//         th[style*="text-align:center"] {
//           text-align: center;
//         }

//         /* White space control */
//         th[style*="white-space:nowrap"],
//         td[style*="white-space:nowrap"] {
//           white-space: nowrap;
//         }
//       </style>
//     </head>
//     <body>
//       ${printContents}
//     </body>
//     </html>
//   `);

//   printWindow.document.close();
//   printWindow.focus();

//   // Wait for content to load before printing
//   setTimeout(() => {
//     printWindow.print();
//     printWindow.close();
//   }, 250);
// }

printPage42(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          /* ===== ENSURE COLORS & BORDERS PRINT ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 PORTRAIT PAGE ===== */
          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm; /* top right bottom left */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;   /* outer border */
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== FOOTER ===== */
          tfoot {
            display: table-row-group;
            font-weight: bold;
          }

          /* ===== PRINT ONLY ===== */
          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}
printPage43(): void {

  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const printWindow = window.open('', '', 'width=900,height=1200');

  printWindow!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>

        <style>

          /* ================= FORCE COLORS & BORDERS ================= */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          /* ================= A4 PORTRAIT ================= */
          @page {
            size: A4 portrait;
            margin: 8mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
          }

          /* ================= TABLE ================= */
          table {
            width: 99.7%;                 /* FIX FOR RIGHT BORDER */
            border-collapse: collapse;
            border: 1px solid #000;
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: normal;          /* VERY IMPORTANT */
            text-align: left;
          }

          /* FORCE RIGHT BORDER */
          th:last-child,
          td:last-child {
            border-right: 1 px solid #000 !important;
          }

          /* ================= HEADER REPEAT ================= */
          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ================= PRINT ONLY ================= */
          @media print {
            .noPrint {
              display: none !important;
            }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  printWindow!.document.close();
  printWindow!.focus();

  setTimeout(() => {
    printWindow!.print();
    printWindow!.close();
  }, 500);
}




printPageA4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=1400,height=900');

  WindowPrt!.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title>Book Credit Note Report</title>

  <style>
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      box-sizing: border-box !important;
    }

    @page {
      size: A4 landscape;
      margin: 8mm 8mm 8mm 12mm;
    }

    body {
      margin: 0;
      font-family: Arial, sans-serif;
      font-size: 12px;
      color: #000;
    }

    table {
      width: calc(100% - 1px);
      border-collapse: collapse;
      table-layout: auto;   /* 🔥 CRITICAL CHANGE */
      border: 1px solid #000;
    }

    th, td {
      border: 1px solid #000;
      padding: 5px 6px;
      vertical-align: middle;
      text-align: left;
    }

    /* DEFAULT CELLS */
    td {
      white-space: nowrap;
    }

    /* 🔥 BOOK SELLER NAME FIX */
    td.seller-name {
      white-space: normal !important;
      word-break: break-word;
      overflow: visible;
      max-width: 350px;   /* adjust if needed */
    }

    th:last-child,
    td:last-child {
      border-right: 1px solid #000 !important;
    }

    th:first-child,
    td:first-child {
      border-left: 1px solid #000 !important;
    }

    thead {
      display: table-header-group;
    }

    tr {
      page-break-inside: avoid;
    }

    @media print {
      .noPrint { display: none !important; }
    }
  </style>
</head>

<body>
  ${printContent.innerHTML}
</body>
</html>
`);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 600);
}



  printPageA41(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          /* ===== ENSURE COLORS & BORDERS PRINT ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 PORTRAIT PAGE ===== */
          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm; /* top right bottom left */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
            -webkit-font-smoothing: none;
            border-right: 1px solid #000 !important;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;   /* outer border */
            border-right: 1px solid #000 !important;

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
            border-right: 1px solid #000 !important;
          }

          thead {
            display: table-header-group;
            border-right: 1px solid #000 !important;
          }

          tr {
            page-break-inside: avoid;
            border-right: 1px solid #000 !important;
          }

          /* ===== FOOTER ===== */
          tfoot {
            display: table-row-group;
            font-weight: bold;
            border-right: 1px solid #000 !important;
          }

          /* ===== PRINT ONLY ===== */
          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}










// print() {
//   const printContents = this.printSection.nativeElement.innerHTML;
//   const popupWindow = window.open('', '_blank', 'width=1000,height=800');

//   if (popupWindow) {
//     popupWindow.document.open();
//     popupWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             body {
//               font-family: Arial, sans-serif;
//               -webkit-print-color-adjust: exact !important;
//               print-color-adjust: exact !important;
//             }
//             table {
//               width: 100%;
//               border-collapse: collapse;
//             }
//             th, td {
//               border: 1px solid #ccc;
//               padding: 8px;
//               text-align: left;
//             }
//             .highlight {
//               background-color: #f2f2f2 !important;
//               color: black;
//             }
//           </style>
//         </head>
//         <body onload="window.print(); window.close();">
//           ${printContents}
//         </body>
//       </html>
//     `);
//     popupWindow.document.close();
//   }
// }

}
